import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Loader } from '@anex/common';
export var ConfirmAddress = inject('checkAddressStore')(observer(function (props) {
    return (React.createElement("div", { className: "panel" },
        React.createElement(Loader, { loading: props.checkAddressStore.loading, text: "Please wait,we are processing your request ..." }),
        React.createElement("h3", null, "Is this your address?"),
        React.createElement("div", { className: "address-selector-module" },
            React.createElement("p", null, "Choose your address from the list below."),
            React.createElement("div", { className: "address-selector-list" }, props.checkAddressStore.addressesResponse.map(function (address, index) { return (React.createElement("div", { className: "address-selector-item", key: index },
                React.createElement("p", null,
                    React.createElement("strong", null, "Address:"),
                    " ",
                    address.formattedAddress,
                    React.createElement("br", null),
                    React.createElement("strong", null, "Location ID:"),
                    ' ',
                    address.providers[0].locationId,
                    ' '),
                React.createElement("button", { className: "btn btn-primary", type: "button", onClick: function () {
                        return props.checkAddressStore.qualifyByAddress(address);
                    } }, "This is my address"))); }))),
        React.createElement("p", null,
            React.createElement("button", { type: "button", className: "btn btn-link btn-sm text-highlight", onClick: props.onRetryClick }, "Try a different address"))));
}));
//# sourceMappingURL=ConfirmAddress.js.map